module.exports = __webpack_public_path__ + "static/media/updateBag.55a19289.png";